const toastsActions = {
    SHOW: "SHOW",
    HIDE: "HIDE"
}

export default toastsActions;